import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import { pushToDataLayer } from '../gaTracker';
import { getSectionCategorySubCat } from '../getSectionCategorySubCat';
export var ecommEdit = function ecommEdit(product) {
  var categories = getSectionCategorySubCat(product.detailLink);
  var ecommerceObj = {
    event: 'editInCart',
    ecommerce: {
      edit: {
        currencyCode: 'USD',
        products: [_objectSpread(_objectSpread({}, product), {}, {
          section: categories[0] || '',
          category: categories[1] || '',
          'sub-category': categories[2] || ''
        })]
      }
    }
  };
  pushToDataLayer(ecommerceObj);
};